import { IItem } from '@checkout/items';
import { ILoggedIn, IPaymentMethod, RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Sticky, StickyContainer } from 'react-sticky';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { compose } from 'redux';
import { FlatCheckout, InformationBox, OrderHeader, OrderSummary, Overlay, Steps, Wallet } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { layoutTypes } from '../../../config/contextCheckoutConfig';
import { toggleMembershipOverlay } from '../../../reducers/checkout';
import { isKlarnaCheckoutAvailable } from '../../../utils/paymentMethods';
import CheckoutForm from '../CheckoutForm/CheckoutForm';
import { getUrlVars, isMediumDevice } from './../../../utils/utils';
import { Column, EmptyBagInfo } from './../../presentational';
import * as Styles from './Layout.scss';

interface IOwnProps {
  items: IItem[];
}

interface IConnectedProps {
  grandTotalPrice: string;
  loggedIn: ILoggedIn | null;
  paymentMethods: IPaymentMethod[];
}

interface IConnectetDispatchProps {
  toggleMembershipOverlay: typeof toggleMembershipOverlay;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

interface IOwnState {
  isOrderSummaryActive: boolean;
  isMobile: boolean;
}

class Layout extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    isOrderSummaryActive: false,
    isMobile: true,
  };

  componentDidMount() {
    this.handleCheckDeviceSize();
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleCheckDeviceSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleCheckDeviceSize);
  }

  handleCheckDeviceSize = () => {
    this.setState({ isMobile: isMediumDevice() });
  }

  toggleOrderSummary = () => {
    const { isOrderSummaryActive } = this.state;
    this.setState({ isOrderSummaryActive: !isOrderSummaryActive });
  }

  handleMembershipOpen = () => {
    const { toggleMembershipOverlay: toggleOverlay } = this.props;
    toggleOverlay({ isOpen: true });
  }

  // TODO - IE 10 is not suporting .get
  isWalletPage = () => getUrlVars().get('wallet');

  render() {
    const { intl, items, grandTotalPrice, loggedIn, paymentMethods } = this.props;
    const { isMobile, isOrderSummaryActive } = this.state;

    const showOrderSummaryColumn = !isMobile || (isMobile && isOrderSummaryActive);
    const showCheckoutContent = !isMobile || (isMobile && !isOrderSummaryActive);
    const noItemsInBag = !items || (items && items.length === 0);
    const isKCOAvailable = isKlarnaCheckoutAvailable(paymentMethods);

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <StickyContainer>
            <Overlay />
            {noItemsInBag && <EmptyBagInfo intl={intl} handleMembershipOpen={this.handleMembershipOpen} loggedIn={loggedIn} />}
            {!noItemsInBag && (
              <div className={Styles.wrap} is-klarna-checkout-available={isKCOAvailable ? 'true' : 'false'}>
                <div className={Styles.container}>
                  {isMobile && (
                    <Sticky>
                      {({
                        style,
                        isSticky,
                        wasSticky,
                        distanceFromTop,
                        distanceFromBottom,
                        calculatedHeight
                      }) => (
                        <OrderHeader
                          isSticky={isSticky}
                          style={style}
                          isOrderSummaryActive={isOrderSummaryActive}
                          grandTotalPrice={grandTotalPrice}
                          onRightButtonClick={this.toggleOrderSummary}
                        />
                      )}
                    </Sticky>
                  )}
                  <div className={Styles.columns}>
                    <Column small={true}>
                      <TransitionGroup>
                        {showOrderSummaryColumn && (
                          <CSSTransition classNames="fadeDown" timeout={{ enter: 600, exit: 350 }}>
                            <OrderSummary toggleOrderSummary={this.toggleOrderSummary} isMobile={isMobile} />
                          </CSSTransition>
                        )}
                      </TransitionGroup>
                    </Column>
                    <Column>
                      <TransitionGroup className={Styles.content}>
                      {checkoutContextConfig.ui.informationBox.enabled && <InformationBox />}
                        {showCheckoutContent && (
                          <CSSTransition classNames="fadeDown" timeout={{ enter: 1000, exit: 350 }}>
                            {this.isWalletPage() && checkoutContextConfig.modules.wallet.isEnabled ? (
                              <Wallet />
                            ) : (
                              <Fragment>
                                {checkoutContextConfig.ui.layout.type === layoutTypes.flat &&
                                  <CheckoutForm>
                                    <FlatCheckout isMobile={isMobile} />
                                  </CheckoutForm>
                                }
                                {checkoutContextConfig.ui.layout.type === layoutTypes.steps &&
                                  <Steps stepsContextConfig={checkoutContextConfig.ui.steps} />
                                }
                              </Fragment>
                            )}
                          </CSSTransition>
                        )}
                      </TransitionGroup>
                    </Column>
                  </div>
                </div>
              </div>
            )}
          </StickyContainer>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      grandTotalPrice: state.checkout.selection && state.checkout.selection.totals && state.checkout.selection.totals.grandTotalPrice,
      loggedIn: state.checkout.loggedIn,
      paymentMethods: state.checkout.paymentMethods,
    }),
    {
      toggleMembershipOverlay
    },
  )
)(Layout);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Layout/Layout.tsx